// AUTO-GENERATED from services/app-api-service/codeigniter/application/contracts/Payroll_EmployeeAdvancesResponse.php
// Do not edit by hand — edit the PHP ResponseContract and the sync hook will regenerate this file.
// Bulk regeneration: scripts/sync-contracts/sync-all.sh

import type { Payroll_AdvanceRow } from './Payroll_AdvanceRow'
import type { ApiResponse } from '../services/httpService'
import { registerResponseContract } from './validate'

export type Payroll_EmployeeAdvancesResponseDados = Payroll_AdvanceRow[];

export type Payroll_EmployeeAdvancesResponse = ApiResponse<Payroll_EmployeeAdvancesResponseDados>;

registerResponseContract('Payroll_EmployeeAdvancesResponse', {
  _root: {
    type: 'array',
    required: true,
    items: {
      id:                    { type: 'number',  required: true },
      employee_id:           { type: 'string',  required: true },
      franchise_id:          { type: 'number',  required: true },
      source_type:           { type: 'string',  required: true },
      recebimento_id:        { type: 'number',  required: false },
      origin_period_id:      { type: 'number',  required: false },
      title:                 { type: 'string',  required: true },
      description:           { type: 'string',  required: false },
      amount:                { type: 'string',  required: true },
      request_date:          { type: 'string',  required: true },
      status:                { type: 'number',  required: true },
      amount_paid:           { type: 'string',  required: true },
      despesa_id:            { type: 'number',  required: false },
      created_at:            { type: 'string',  required: true },
      created_by:            { type: 'string',  required: true },
      updated_at:            { type: 'string',  required: false },
      linked_despesa_status: { type: 'number',  required: false },
      employee_name:         { type: 'string',  required: false },
    },
  },
})
